export default "__VITE_ASSET__VsjuB0fe__"